<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="Metrics" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { MetricsProps } from './Metrics.ts';
import Metrics from './Metrics.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-metrics';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<MetricsProps>();
const changableProps = useChangableProps(componentName, props);

</script>
